var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "query" }, [
      _c("div", { staticClass: "title" }, [_vm._v(" 查询订单 ")]),
      _c(
        "div",
        { staticClass: "context" },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      size: "mini",
                      "unlink-panels": "",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.dateS,
                      callback: function ($$v) {
                        _vm.dateS = $$v
                      },
                      expression: "dateS",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "订单状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择订单状态" },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    },
                    _vm._l(_vm.state, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "商品仓库" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择商品仓库" },
                      model: {
                        value: _vm.value1,
                        callback: function ($$v) {
                          _vm.value1 = $$v
                        },
                        expression: "value1",
                      },
                    },
                    _vm._l(_vm.wareData, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("搜索订单")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.clearClick },
                    },
                    [_vm._v(" 重置 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "top" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("出库订单")]),
                  ]),
                  _c("div", { staticClass: "date" }, [
                    _c("span", [_vm._v(_vm._s(_vm.time))]),
                  ]),
                  _vm._l(_vm.datas.outOrder, function (item) {
                    return _vm.datas
                      ? _c("div", { staticClass: "text" }, [
                          _c("span", [_vm._v(_vm._s(item.label) + ": ")]),
                          _c("span", [_vm._v(_vm._s(item.value) + "单")]),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]),
            _c("el-col", { attrs: { span: 18 } }, [
              _c("div", { staticClass: "right" }, [
                _c("div", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: { id: "chartLineBox" },
                }),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "top" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("入库订单")]),
                  ]),
                  _c("div", { staticClass: "date" }, [
                    _c("span", [_vm._v(_vm._s(_vm.time))]),
                  ]),
                  _vm._l(_vm.datas.inOrder, function (item) {
                    return _vm.datas
                      ? _c("div", { staticClass: "text" }, [
                          _c("span", [_vm._v(_vm._s(item.label) + ": ")]),
                          _c("span", [_vm._v(_vm._s(item.value) + "单")]),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]),
            _c("el-col", { attrs: { span: 18 } }, [
              _c("div", { staticClass: "right" }, [
                _c("div", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: { id: "chartLineBx" },
                }),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }